/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// reactstrap components
import {
  Badge,
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";
// core components
import IndexNavbar from "components/Navbars/IndexNavbar.jsx";
import IndexHeader from "components/Headers/IndexHeader.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";

class Index extends React.Component {
  render() {
    return (
      <>
        <IndexNavbar />
        <div className="main-content">
          <IndexHeader />
          <section className="py-6 pb-9 bg-default">
            <Container fluid>
              <Row className="justify-content-center text-center">
                <Col md="6">
                  <h2 className="display-3 text-white">
                    A complete QR Code solution
                  </h2>
                  <p className="lead text-white">
                    Serve QR is a completly new product built on top of amazing technology stack.
                    It's meant to give you a robust platform which would help you grow your businesses.
                  </p>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="section section-lg pt-lg-0 mt--7">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape bg-gradient-info text-white rounded-circle mb-4">
                            <i className="fab fa-react" />
                          </div>
                          <h4 className="h3 text-info text-uppercase">
                            Based on React and Reactstrap
                          </h4>
                          <p className="description mt-3">
                            Front-end in Serve QR is built on top of the most popular open
                            source toolkit for developing with HTML, CSS, and JS.
                          </p>
                          <div>
                            <Badge color="info" pill>
                              react
                            </Badge>
                            <Badge color="info" pill>
                              reactstrap
                            </Badge>
                            <Badge color="info" pill>
                              dashboard
                            </Badge>
                            <Badge color="info" pill>
                              template
                            </Badge>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape bg-gradient-success text-white rounded-circle mb-4">
                            <i className="fa fa-desktop" />
                          </div>
                          <h4 className="h3 text-success text-uppercase">
                            Responsive UI
                          </h4>
                          <p className="description mt-3">
                            Serve QR is built keeping in mind the various devices and form factor.
                            It can easily scale up and down without compromising on the features it provides.
                          </p>
                          <div>
                            <Badge color="success" pill>
                              Bootstrap
                            </Badge>
                            <Badge color="success" pill>
                              Fast UI
                            </Badge>
                            <Badge color="success" pill>
                              Lightweight
                            </Badge>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col lg="4">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          <div className="icon icon-shape bg-gradient-warning text-white rounded-circle mb-4">
                            <i className="fa fa-cloud-upload-alt" />
                          </div>
                          <h4 className="h3 text-warning text-uppercase">
                            Full Cloud support
                          </h4>
                          <p className="description mt-3">
                            Serve QR is deployed in the Cloud Servers which makes it more robust and is always online and available.
                          </p>
                          <div>
                            <Badge color="warning" pill>
                              cloud
                            </Badge>
                            <Badge color="warning" pill>
                              always on
                            </Badge>
                            <Badge color="warning" pill>
                              robust
                            </Badge>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-6">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={require("assets/img/theme/landing-1.png")}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1>Awesome features</h1>
                    <p>
                      Serve QR comes with an amazing Dashboard to help you know more about the Stats of the QR Codes categorized into Month, Geography and Referrers.
                    </p>
                    <ul className="list-unstyled mt-5">
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-settings-gear-65" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">
                              Carefully crafted components
                            </h4>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="fa fa-chart-line" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">Amazing graphs</h4>
                          </div>
                        </div>
                      </li>
                      <li className="py-2">
                        <div className="d-flex align-items-center">
                          <div>
                            <Badge
                              className="badge-circle mr-3"
                              color="success"
                            >
                              <i className="ni ni-satisfied" />
                            </Badge>
                          </div>
                          <div>
                            <h4 className="mb-0">
                              Super friendly support team
                            </h4>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-6">
            <Container>
              <Row className="row-grid align-items-center">
                <Col md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={require("assets/img/theme/landing-2.png")}
                  />
                </Col>
                <Col md="6">
                  <div className="pr-md-5">
                    <h1>QR Codes Page</h1>
                    <p>
                      Get details of all your QR Codes in one place. Here you can add, edit, download and remove a QR Code.
                    </p>
                    {/* <Link
                      className="font-weight-bold text-warning mt-5"
                      to="/admin/profile"
                    >
                      Explore pages
                    </Link> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          <section className="py-6">
            <Container>
              <Row className="row-grid align-items-center">
                <Col className="order-md-2" md="6">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={require("assets/img/theme/landing-3.png")}
                  />
                </Col>
                <Col className="order-md-1" md="6">
                  <div className="pr-md-5">
                    <h1>Lovable widgets and cards</h1>
                    <p>
                      We love cards and everybody on the web seems to. We have
                      gone above and beyond with options for you to organise
                      your information. From cards designed for content, to
                      pricing cards or user profiles, you will have many options
                      to choose from.
                    </p>
                    {/* <Link
                      className="font-weight-bold text-info mt-5"
                      to="/admin/widgets"
                    >
                      Explore widgets
                    </Link> */}
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
          {/* <section className="py-7 section-nucleo-icons bg-white overflow-hidden">
            <Container>
              <Row className="justify-content-center">
                <Col className="text-center" lg="8">
                  <h2 className="display-3">Nucleo Icons</h2>
                  <p className="lead">
                    The official package contains over 21.000 icons which are
                    looking great in combination with Argon Design System. Make
                    sure you check all of them and use those that you like the
                    most.
                  </p>
                  <div className="btn-wrapper">
                    <Button
                      color="info"
                      href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/icons?ref=adpr-index-page"
                      target="_blank"
                    >
                      View demo icons
                    </Button>
                    <Button
                      className="mt-3 mt-md-0"
                      color="default"
                      href="https://nucleoapp.com/?ref=1712"
                      target="_blank"
                    >
                      View all icons
                    </Button>
                  </div>
                </Col>
              </Row>
              <div className="blur--hover">
                <a
                  href="https://demos.creative-tim.com/argon-dashboard-pro-react/#/documentation/icons?ref=adpr-index-page"
                  target="_blank"
                >
                  <div className="icons-container blur-item mt-5">
                    <i className="icon ni ni-diamond" />

                    <i className="icon icon-sm ni ni-album-2" />
                    <i className="icon icon-sm ni ni-app" />
                    <i className="icon icon-sm ni ni-atom" />

                    <i className="icon ni ni-bag-17" />
                    <i className="icon ni ni-bell-55" />
                    <i className="icon ni ni-credit-card" />

                    <i className="icon icon-sm ni ni-briefcase-24" />
                    <i className="icon icon-sm ni ni-building" />
                    <i className="icon icon-sm ni ni-button-play" />

                    <i className="icon ni ni-calendar-grid-58" />
                    <i className="icon ni ni-camera-compact" />
                    <i className="icon ni ni-chart-bar-32" />
                  </div>
                  <span className="blur-hidden h5 text-success">
                    Eplore all the 21.000+ Nucleo Icons
                  </span>
                </a>
              </div>
            </Container>
          </section> */}
          <section className="py-7">
            <Container>
              <Row className="row-grid justify-content-center">
                <Col className="text-center" lg="8">
                  <h2 className="display-3">
                    Do you love this awesome{" "}
                    <span className="text-success">
                      Serve QR?
                    </span>
                  </h2>
                  <p className="lead">
                    Cause if you do, you can use it almost immediately. Hit the button below
                    to navigate to the Register or Login depending on your choice.
                    Easily create a new QR Code and see it working.
                  </p>
                  <div className="btn-wrapper">
                    <Button
                      className="btn-neutral mb-3 mb-sm-0"
                      color="default"
                      href="/auth/register"
                      // target="_blank"
                    >
                      <span className="btn-inner--text">Register</span>
                    </Button>
                    <Button
                      className="btn-icon mb-3 mb-sm-0"
                      color="info"
                      href="/auth/login"
                      // target="_blank"
                    >
                      <span className="btn-inner--icon">
                        <i className="fa fa-sign-in-alt" />
                      </span>
                      <span className="btn-inner--text">Login</span>
                      {/* <Badge
                        className="badge-md badge-floating border-white"
                        color="danger"
                        pill
                      >
                        $89
                      </Badge> */}
                    </Button>
                  </div>
                  {/* <div className="text-center">
                    <h4 className="display-4 mb-5 mt-5">
                      Available on these technologies
                    </h4>
                    <Row className="justify-content-center">
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro?ref=adpr-index-page"
                          id="tooltip170669606"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle shadow shadow-lg--hover"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/bootstrap.jpg"
                          />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip170669606"
                        >
                          Bootstrap 4 - Most popular front-end component library
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro-react?ref=adpr-index-page"
                          id="tooltip374813715"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/react.jpg"
                          />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip374813715"
                        >
                          React - A JavaScript library for building user
                          interfaces
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro-nodejs?ref=adpr-index-page"
                          id="tooltip374813715"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/nodejs-logo.jpg"
                          />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip374813715"
                        >
                          React - A JavaScript library for building user
                          interfaces
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.creative-tim.com/product/argon-dashboard-pro-laravel?ref=adpr-index-page"
                          id="tooltip374813715"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/laravel_logo.png"
                            style={{ backgroundColor: "white" }}
                          />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip374813715"
                        >
                          React - A JavaScript library for building user
                          interfaces
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://vuejs.org/?ref=creative-tim"
                          id="tooltip616015001"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle opacity-3"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/vue.jpg"
                          />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip616015001"
                        >
                          [Coming Soon] Vue.js - The progressive javascript
                          framework
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.sketchapp.com/?ref=creative-tim"
                          id="tooltip82987604"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle opacity-3"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/sketch.jpg"
                          />
                        </a>
                        <UncontrolledTooltip delay={0} target="tooltip82987604">
                          [Coming Soon] Sketch - Digital design toolkit
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://www.adobe.com/products/photoshop.html?ref=creative-tim"
                          id="tooltip731835410"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle opacity-3"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/ps.jpg"
                          />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip731835410"
                        >
                          [Coming Soon] Adobe Photoshop - Software for digital
                          images manipulation
                        </UncontrolledTooltip>
                      </Col>
                      <Col className="my-2" md="2" xs="3">
                        <a
                          href="https://angularjs.org/?ref=creative-tim"
                          id="tooltip211254026"
                          target="_blank"
                        >
                          <img
                            alt="..."
                            className="img-fluid rounded-circle opacity-3"
                            src="https://raw.githubusercontent.com/creativetimofficial/public-assets/master/logos/angular.jpg"
                          />
                        </a>
                        <UncontrolledTooltip
                          delay={0}
                          target="tooltip211254026"
                        >
                          [Coming Soon] Angular - One framework. Mobile &
                          desktop
                        </UncontrolledTooltip>
                      </Col>
                    </Row>
                  </div> */}
                </Col>
              </Row>
            </Container>
          </section>
        </div>
        <AuthFooter />
      </>
    );
  }
}

export default Index;
